import React from 'react';
import { connect } from 'react-redux';
import Icon from './Icon';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import SwitchToggle from 'material-ui/Toggle';

import {
  setLogoElementWidth,
  setLogoElementHeight,
  setLogoElementLinkHomepage,
  setLogoElementMargin,
  setLogoElementPadding
} from '../actions/logo-element-actions';

import styles from '../../../../stylesheet/css/header-builder/logo-element-options.css';

/**
 * Margin and Padding temporary variable to save current data.
 * @type {Object}
 */
let paddingLogo = {};
let marginLogo = {};

/**
 * Margin and Padding render input element.
 * @param  {int}    i              Element ID.
 * @param  {string} indexDir       Property name.
 * @param  {object} values         Current property value.
 * @param  {string} functionChange Function name will be called when the value is changed.
 * @return {string}                Rendered input for margins and paddings.
 */
const renderDirection = ( i, indexDir, values, functionChange ) => {
  const handleElementChange = e => functionChange( e.target.id, e.target.value );
  const handleElementKeyDown = e => onInputKeyDown( e, functionChange );

  return (
    <input key={i} onBlur={onInputBlur} onKeyDown={handleElementKeyDown} type="text" className={styles.numberBox + ' ' + styles[ indexDir ]} value={ values.hasOwnProperty( indexDir ) ? values[ indexDir ] : '0' } onChange={ handleElementChange } id={ indexDir } />
  );
};

/**
 * Margin and Padding render inputs group element.
 * @param  {string} type           Property type, padding or margin.
 * @param  {object} values         The value of the properties.
 * @param  {string} functionChange Function name will be called when the value is changed.
 * @return {string}                Rendered inputs group for margins and paddings.
 */
const renderDirections = ( type, values, functionChange ) => {
  const result = [];
  const list = [ 'Top', 'Right', 'Bottom', 'Left' ];
  values = ( typeof( values ) == 'object' ) ? values : {};
  list.forEach( function( value, i ) {
    result.push( renderDirection( i, type + value, values, functionChange ) );
  });
  return result;
};

/**
 * Check if the object is empty or not.
 * @param  {object} obj Object need to check.
 * @return {boolean}    The status of object content. False if empty.
 */
const checkEmptyObject = (obj) => {
  if ( typeof obj == 'object' && Object.keys(obj).length > 0 ) {
    return true;
  }
  return false;
};

/**
 * Trigger key down event in input.
 * @param  {object}  e              Event of the trigger.
 * @param  {string}  functionChange Function will be called after the event triggered.
 * @return {boolean}                Return true if the key is allowed.
 */
const onInputKeyDown = (e, functionChange) => {
  var keyCode = e.keyCode;

  if (keyCode == 38 || keyCode == 40) {
    /* Arrow up and down */
    e.preventDefault();
    var val = parseInt(e.target.value);

    if(val || val == 0){
      switch (keyCode) {
        case 38: {
          val = val+1;
          e.target.value=val;
          break;
        }
        case 40: {
          if (val <= 0) {}
          else{
            val = val-1;
            e.target.value = val;
          }
          break;
        }
      }
    } else {
      e.target.value=0;
    }

    functionChange(e.target.id, e.target.value);

    return true;
  }

  if ( keyCode == 37 || keyCode == 39 || (keyCode >= 48 && keyCode <= 57) || keyCode == 8 || keyCode == 46 ) {}
  else{e.preventDefault(); return false;}
};

/**
 * Trigger input blur event. Set the value to 0 when the target value is empty.
 * @param  {object} e Event of the trigger.
 */
const onInputBlur = (e) => {
  var val = e.target.value;
  if (val == '') {
    e.target.value=0;
  }
};

/**
 * Set temporary Padding & Margin values.
 * @param  {object} elementLogo Temporary margin/padding properties value.
 * @param  {string} id          Element ID.
 * @param  {string} inputId     Property name.
 * @param  {string} value       Property value.
 * @return {object}             The updated padding/margin properties value.
 */
const setElementValues = ( elementLogo, id, inputId, value ) => {
  let elementLogoTemp = ( elementLogo.hasOwnProperty( id ) ) ? elementLogo[ id ] : {};
  elementLogoTemp = ( typeof( elementLogoTemp ) == 'object' ) ? elementLogoTemp : {};
  elementLogoTemp[ inputId ] = value;
  return elementLogoTemp;
};

/**
 * Set the SVG icon.
 * @param  {string} id SVG Icon ID.
 * @return {string}    SVG Icon markup.
 */
const getIcon = (id) => {
  switch( id ) {
    case 'margin-padding': {
      return <Icon icon="margin-padding-container" w="238px" h="164px" vb="0 0 238 164" fill="#6b6b6b"/>;
    }
    default: {
      return '';
    }
  }
}

/**
 * Material UI theme settings.
 * @type {object}
 */
const muiTheme = getMuiTheme({
  toggle: {
    thumbOnColor: '#37C4FF',
    trackOnColor: '#46626E'
  }
});

/**
 * Render Material UI Toggle element.
 * @param  {boolean} value          Value of toggle element.
 * @param  {string}  functionChange Function will be called after the event triggered.
 * @return {string}                 Rendered toggle element markup.
 */
const SwitchToggleProp = ( value, functionChange ) => {
  if ( typeof value != 'boolean' ) {
    value = false;
  }

  const handleLinkHomepageChange = ( e, isInputChecked ) => functionChange( event, isInputChecked );

  return (
    <MuiThemeProvider muiTheme={muiTheme}>
      <SwitchToggle defaultToggled={value} onToggle={handleLinkHomepageChange} />
    </MuiThemeProvider>
  );
};

export const LogoOptions = ({
  id,
  onWidthChange,
  onHeightChange,
  onLinkHomepageChange,
  onMarginChange,
  onPaddingChange,
  options = {}
}) => {
  const { width, height, linkHomepage, margin, padding } = options;
  const handleWidthChange = e => onWidthChange(e.target.value);
  const handleHeightChange = e => onHeightChange(e.target.value);

  // Set temporary padding for the element.
  if ( checkEmptyObject(paddingLogo) && ! paddingLogo.hasOwnProperty(id) ) {
    paddingLogo[id] = padding;
  }

  // Set temporary margin for the element.
  if ( checkEmptyObject(marginLogo) && ! marginLogo.hasOwnProperty(id)  ) {
    marginLogo[id] = margin;
  }

  return (
    <div>
      <div className={styles.colPanel}>
        <header className={styles.colPanelName}>Properties</header>
        <div className={styles.row}>
          <div className={styles.colOneOfTwo}>
            <div className={styles.fieldGroup}>
              <label className={styles.fieldLabel}>Width</label>
              <input className={styles.fieldInput} type="text" value={ ! width ? '' : width } onChange={handleWidthChange} />
              <span className={styles.fieldInputAddon}>px</span>
            </div>
          </div>
          <div className={styles.colOneOfTwo}>
            <div className={styles.fieldGroup + ' ' + styles.fieldGroupRight}>
              <label className={styles.fieldLabel}>Height</label>
              <input className={styles.fieldInput} type="text" value={ ! height ? '' : height } onChange={handleHeightChange} />
              <span className={styles.fieldInputAddon}>px</span>
            </div>
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.colOneOfOne}>
            <div className={styles.fieldGroup}>
              <label className={styles.fieldLabel}>Link to Homepage</label>
              <div className={styles.fieldCustom}>
                { SwitchToggleProp( linkHomepage, onLinkHomepageChange ) }
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.colPanel}>
        <header className={styles.colPanelName}>Layout</header>
        <div className={styles.box}>
          { getIcon( 'margin-padding' ) }
          { renderDirections( 'padding', padding, onPaddingChange ) }
          { renderDirections( 'margin', margin, onMarginChange ) }
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = ( dispatch, ownProps ) => {
  const { device, id } = ownProps;

  return {
    onWidthChange( value ) {
      dispatch( setLogoElementWidth({ device, id, value }));
    },
    onHeightChange( value ) {
      dispatch( setLogoElementHeight({ device, id, value }));
    },
    onLinkHomepageChange( event, value ) {
      dispatch( setLogoElementLinkHomepage({ device, id, value }));
    },
    onPaddingChange( inputId, value) {
      paddingLogo = ( typeof( paddingLogo ) == 'object' ) ? paddingLogo : {};
      let paddingLogoTemp = setElementValues( paddingLogo, id, inputId, value );
      paddingLogo[ id ] = paddingLogoTemp;
      dispatch( setLogoElementPadding({ device, id, value: paddingLogoTemp }));
    },
    onMarginChange( inputId, value ) {
      marginLogo = ( typeof( marginLogo ) == 'object' ) ? marginLogo : {};
      let marginLogoTemp = setElementValues( marginLogo, id, inputId, value );
      marginLogo[ id ] = marginLogoTemp;
      dispatch( setLogoElementMargin({ device, id, value: marginLogoTemp }));
    },
  };
};

export default connect(
  null,
  mapDispatchToProps
)(LogoOptions);


// WEBPACK FOOTER //
// ./app/header-builder/components/LogoOptions.js